import { render } from "./SpotDetail.vue?vue&type=template&id=78b28520&scoped=true"
import script from "./SpotDetail.vue?vue&type=script&lang=js"
export * from "./SpotDetail.vue?vue&type=script&lang=js"

import "./SpotDetail.vue?vue&type=style&index=0&id=78b28520&lang=scss&scoped=true"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b28520"]])

export default __exports__